import React from "react";
import { Page, NavItem, TabPane} from "components/common";
import { XeroClient } from "services";
import { compose } from "recompose";
import { Nav, TabContent } from "reactstrap";
import Table from "./TableCreditNote";
import { Trans } from "react-i18next";
import { Link, Switch, Redirect } from "react-router-dom";
import { renderCountSpan } from "services/util";
import { useQuery } from "react-query";
import { useNonReportedTotals } from "hooks/useNonReportedTotals";
import { useOrganisationContext } from "hooks";
import Warning from "./Warning";


const accPayCheck = /purchases|payable|accounts_payable/g

const getTable = (Statuses, isReporting) => (props) =>{
  const { selectedOrganisation } = useOrganisationContext();
  let raw = `(${Statuses.split(",").map((i) => `Status="${i}"`).join(" OR ")}) AND ${props.location.pathname.match(accPayCheck) ? 'TYPE="ACCPAYCREDIT"' : 'TYPE="ACCRECCREDIT"'}`
  raw = isReporting ? `${raw} AND Date >= DateTime(${selectedOrganisation.onboarding_date})` : raw

  if (isReporting && selectedOrganisation.pos_contacts_ids) {
    const contactIds = selectedOrganisation.pos_contacts_ids?.split(',') || []
    const filterStrings = contactIds.map(contactId => `Contact.ContactID!=GUID("${contactId}")`);
    raw = `${raw} AND (` + filterStrings.join(" AND ") + ')'
  }

  return(
    <Table
      filters={{
        extra_params: {
          Statuses,
          Type: props.location.pathname.match(accPayCheck) ? "ACCPAYCREDIT" : "ACCRECCREDIT",
        },
        raw: raw,
      }}
      status={Statuses}
      {...props}
    />
  );
}

const All = getTable("DRAFT,SUBMITTED,AUTHORISED,PAID");
const Draft = getTable("DRAFT");
const AwaitingApproval = getTable("SUBMITTED");
const Approved = getTable("AUTHORISED");
const Paid = getTable("PAID");
const Reporting = getTable("PAID,AUTHORISED", true);

export const ListCreditNotes = ({ match }) => {

  const currentUrl = window.location.href;
  const isPayable = accPayCheck.test(currentUrl);

  const typeOfCN = isPayable ? 'Type="ACCPAYCREDIT"' : 'Type="ACCRECCREDIT"';

  const xero = XeroClient();
  const { selectedOrganisation } = useOrganisationContext()
  
  const { data: counts } = useQuery(["creditnotes/get_pagination_data", typeOfCN], () => xero.get("creditnotes/get_pagination_data", {
    params: {
      raw: `${typeOfCN}`
    }
  }).get("data"), {
    refetchOnMount: true,
  });
  
  const { data, refetch } = useNonReportedTotals({ enabled: !isPayable });

  return (
    <Page className="inv-tabs nw-list">
        <div>
         <Link to={`${match.url}/edit/new`} className="btn btn-primary ml-0">
            <Trans>New Credit Note</Trans>
            <span className="mx-1" />
            <span className="fa fa-plus" />
          </Link>
        </div>
        <Nav tabs className="nw-tabs2 inv-tabs my-3">
          <NavItem to={`all`} translate={false}><Trans>All</Trans> {renderCountSpan(counts?.All?.itemCount)}</NavItem>
          <NavItem to={`draft`} translate={false}><Trans>Draft</Trans> {renderCountSpan(counts?.DRAFT?.itemCount)}</NavItem>
          <NavItem to={`awaiting_approval`} translate={false}><Trans>Awaiting Approval</Trans> {renderCountSpan(counts?.SUBMITTED?.itemCount)}</NavItem>
          <NavItem to={`approved`} translate={false}><Trans>Awaiting Payment</Trans> {renderCountSpan(counts?.AUTHORISED?.itemCount)}</NavItem>
          <NavItem to={`paid`} translate={false}><Trans>Paid</Trans> {renderCountSpan(counts?.PAID?.itemCount)}</NavItem>
        {!isPayable && selectedOrganisation.onboarding_date &&
            <NavItem to={`${match.url}/reporting`} translate={false} className="position-relative">
              <Trans>Zatca Reporting</Trans> ({data?.creditNotes?.itemCount})
              <Warning total_non_reported={data?.creditNotes?.itemCount} />
            </NavItem>
          }
        </Nav>

        <TabContent>
          <Switch>
            <TabPane path={`${match.url}/all`} component={All} />
            <TabPane path={`${match.url}/draft`} component={Draft} />
            <TabPane
              path={`${match.url}/awaiting_approval`}
              component={AwaitingApproval}
            />
            <TabPane path={`${match.url}/approved`} component={Approved} />
            <TabPane path={`${match.url}/paid`} component={Paid} />
            <TabPane path={`${match.url}/reporting`} component={Reporting} isReporting={true} refetch_non_reported={refetch} />
            <Redirect to={`${match.url}/all`} />
          </Switch>
        </TabContent>
    </Page>
  )
};

export const enhance = compose();
export default enhance(ListCreditNotes);
